import { useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { UseSearchStateResult } from './types'

const useSearchState = (debounceDelay: number = 0): UseSearchStateResult => {
  const [searchText, setSearchText] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')

  const debouncedCallback = useDebouncedCallback((text: string) => {
    setDebouncedSearch(text)
  }, debounceDelay)

  const onSearchTextChange = (text: string) => {
    setSearchText(text)
    debouncedCallback(text)
  }

  const clearSearchText = () => {
    setSearchText('')
    setDebouncedSearch('')
  }

  return {
    searchText,
    debouncedSearch,
    onSearchTextChange,
    clearSearchText,
  }
}

export default useSearchState
